import { CommonModule } from '@angular/common';
import { Component, inject, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbActiveModal, NgbDropdownModule, NgbModal, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { CommonService } from '../../../Model/Common/common.service';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { TooltipService } from '../../../Util/Tooltip/tooltip.service';
import { IncometaxService } from '../../../Model/Incometax/incometax.service';
import { NgSelectModule } from '@ng-select/ng-select';
import { ComboService } from '../../../Model/Combo/combo.service';
import { AlertSuccessComponent } from '../../../Component/Alert/alert-success/alert-success.component';
import { AlertWarningComponent } from '../../../Component/Alert/alert-warning/alert-warning.component';
import { CustomDateParserFormatter } from '../../../Util/DateFormat/date-format.service';

@Component({
  selector: 'app-tax-sub-section-form',
  standalone: true,
  imports: [CommonModule, FormsModule, NgSelectModule, NgbDropdownModule],
  providers: [
    { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },
  ],
  templateUrl: './tax-sub-section-form.component.html',
  styleUrl: './tax-sub-section-form.component.scss'
})
export class TaxSubSectionFormComponent {
  isDisabled: boolean = false;
  activeModal = inject(NgbActiveModal);
  @Input() ID!: number;

  TaxSections = [] as any;
  TaxSubSections = [] as any;
  SalaryHeads = [] as any;
  TDSSections = [] as any;
  FinancialYears: any[] = [];
  Detail = {
    SelectType: 'insert',
    ESS_TaxSubSectionFYMasterID: 0,
    ESS_TaxSectionMasterID: null,
    SectionDescription: null,
    ESS_TaxSubSectionMasterID: null,
    SubSectionDescription: null,
    EarningDeduction: null,
    IsOldRegimeApplicable: false,
    IsNewRegimeApplicable: false,
    IsOldMaxlimitapplicable: false,
    IsNewMaxlimitapplicable: false,
    OldRegimeMaxAmount: null as any,
    NewRegimeMaxAmount: null as any,
    FinancialYearStart: null as any,
    FinancialYearEnd: null as any,
    // YearStart: null as any,
    // YearEnd: null as any,
    ESS_TaxFinancialYearID: null,
  }

  constructor(
    private toast: ToastService,
    private modalService: NgbModal,
    protected common: CommonService,
    private tooltip: TooltipService,
    private incometax: IncometaxService,
    private combo: ComboService,
    protected dateFormat: CustomDateParserFormatter,
  ) {
    this.common.getPageRights();
  }

  ngOnInit(): void {
    this.Detail.ESS_TaxSubSectionFYMasterID = this.ID;
    // this.ComboLoad('TDSSectionMaster');
    // this.ComboLoad('SalaryHead');
    this.ESS_TaxFinancialYearSelect();
    if (this.Detail.ESS_TaxSubSectionFYMasterID == undefined) {
      this.Detail.ESS_TaxSubSectionFYMasterID = 0;
    }
  }

  Validate(form: any) {
    if (form.valid) {
      // if (this.Detail.YearStart == null || this.Detail.YearStart.toString().length != 4 || this.Detail.YearStart <= 0) {
      //   this.toast.show({ message: "Please enter financial year start year", type: toastTypeEnum.danger });
      // } else {
      //   this.Detail.FinancialYearStart = "01 APR " + this.Detail.YearStart.toString();
      //   this.Detail.FinancialYearEnd = "31 MAR " + this.Detail.YearEnd.toString();;
      //   this.ESS_TaxSubSectionFYMaster_InsertUpdate();
      // }
      if (this.Detail.IsOldRegimeApplicable || this.Detail.IsNewRegimeApplicable) {
        this.Detail.FinancialYearStart = this.dateFormat.format({ day: new Date(this.FinancialYears.filter(e => e.ESS_TaxFinancialYearID == this.Detail.ESS_TaxFinancialYearID)[0].FinancialYearStart).getDate(), month: new Date(this.FinancialYears.filter(e => e.ESS_TaxFinancialYearID == this.Detail.ESS_TaxFinancialYearID)[0].FinancialYearStart).getMonth() + 1, year: new Date(this.FinancialYears.filter(e => e.ESS_TaxFinancialYearID == this.Detail.ESS_TaxFinancialYearID)[0].FinancialYearStart).getFullYear() });
        this.Detail.FinancialYearEnd = this.dateFormat.format({ day: new Date(this.FinancialYears.filter(e => e.ESS_TaxFinancialYearID == this.Detail.ESS_TaxFinancialYearID)[0].FinancialYearEnd).getDate(), month: new Date(this.FinancialYears.filter(e => e.ESS_TaxFinancialYearID == this.Detail.ESS_TaxFinancialYearID)[0].FinancialYearEnd).getMonth() + 1, year: new Date(this.FinancialYears.filter(e => e.ESS_TaxFinancialYearID == this.Detail.ESS_TaxFinancialYearID)[0].FinancialYearEnd).getFullYear() });

        if (this.Detail.IsOldRegimeApplicable && this.Detail.IsOldMaxlimitapplicable && (this.Detail.OldRegimeMaxAmount == null || this.Detail.OldRegimeMaxAmount == '' || this.Detail.OldRegimeMaxAmount == 0)) {
          this.toast.show({ message: "Please add max limit greter then 0 or remove check box for old regime", type: toastTypeEnum.warning });
        }

        if (this.Detail.IsNewRegimeApplicable && this.Detail.IsNewMaxlimitapplicable && (this.Detail.NewRegimeMaxAmount == null || this.Detail.NewRegimeMaxAmount == '' || this.Detail.NewRegimeMaxAmount == 0)) {
          this.toast.show({ message: "Please add max limit greter then 0 or remove check box for new regime", type: toastTypeEnum.warning });
        }

        if ((!this.Detail.IsOldRegimeApplicable || !this.Detail.IsOldMaxlimitapplicable || (this.Detail.IsOldMaxlimitapplicable && this.Detail.OldRegimeMaxAmount > 0))
          && (!this.Detail.IsNewRegimeApplicable || !this.Detail.IsNewMaxlimitapplicable || (this.Detail.IsNewMaxlimitapplicable && this.Detail.NewRegimeMaxAmount > 0))) {
          this.ESS_TaxSubSectionFYMaster_InsertUpdate();
        }
        
      } else {
        this.toast.show({ message: "Please select old or new regime ot both", type: toastTypeEnum.warning });
      }
    }
    else {
      form.submitted = true;
    }
  }

  // ComboLoad(Combotype: String) {
  //   this.isDisabled = true;
  //   this.combo.ComboLoad({ 'Combotype': Combotype }).subscribe({
  //     next: (response) => {
  //       if (Combotype == 'SalaryHead') {
  //         this.SalaryHeads = response.ComboLoad;
  //       }
  //       else if (Combotype == 'TDSSectionMaster') {
  //         this.TDSSections = response.ComboLoad;
  //       }
  //       this.isDisabled = false;
  //     },
  //     complete: () => { },
  //     error: (error) => {
  //       this.isDisabled = false;
  //     },
  //   });
  // }

  TaxSectionMasterSelectLoad() {
    if (this.Detail.ESS_TaxFinancialYearID == null || this.Detail.ESS_TaxFinancialYearID <= 0) {
      this.toast.show({ message: "Please select financial year", type: toastTypeEnum.danger });
    } else {
      this.isDisabled = true;
      this.Detail.FinancialYearStart = this.dateFormat.format({ day: new Date(this.FinancialYears.filter(e => e.ESS_TaxFinancialYearID == this.Detail.ESS_TaxFinancialYearID)[0].FinancialYearStart).getDate(), month: new Date(this.FinancialYears.filter(e => e.ESS_TaxFinancialYearID == this.Detail.ESS_TaxFinancialYearID)[0].FinancialYearStart).getMonth() + 1, year: new Date(this.FinancialYears.filter(e => e.ESS_TaxFinancialYearID == this.Detail.ESS_TaxFinancialYearID)[0].FinancialYearStart).getFullYear() });
      this.Detail.FinancialYearEnd = this.dateFormat.format({ day: new Date(this.FinancialYears.filter(e => e.ESS_TaxFinancialYearID == this.Detail.ESS_TaxFinancialYearID)[0].FinancialYearEnd).getDate(), month: new Date(this.FinancialYears.filter(e => e.ESS_TaxFinancialYearID == this.Detail.ESS_TaxFinancialYearID)[0].FinancialYearEnd).getMonth() + 1, year: new Date(this.FinancialYears.filter(e => e.ESS_TaxFinancialYearID == this.Detail.ESS_TaxFinancialYearID)[0].FinancialYearEnd).getFullYear() });
      this.incometax.TaxSectionMasterSelectLoad({ SelectType: 'S', ESS_TaxSectionMasterID: 0, FinancialYearFrom: this.Detail.FinancialYearStart, FinancialYearTo: this.Detail.FinancialYearEnd }).subscribe({
        next: (response) => {
          if (response.Table) {
            this.TaxSections = response.Table;
            this.TaxSections.forEach((element: any) => {
              element.SectionLabel = element.SectionCode + ' - ' + element.SectionName;
            });
          } else {
            this.TaxSections = [];
          }
          this.isDisabled = false;
        },
        complete: () => { },
        error: (error) => {
          this.isDisabled = false;
        },
      });
    }
  }

  ESS_TaxSubSectionMasterSelect(isClear = true) {
    if (isClear) {
      this.Detail.ESS_TaxSubSectionMasterID = null;
    }

    if (this.Detail.ESS_TaxSectionMasterID != null && this.Detail.ESS_TaxSectionMasterID > 0) {
      this.isDisabled = true;
      this.incometax.ESS_TaxSubSectionMasterSelect({ SelectType: 'S', ESS_TaxSubSectionMasterID: 0, ESS_TaxSectionMasterID: this.Detail.ESS_TaxSectionMasterID }).subscribe({
        next: (response) => {
          if (response.Table) {
            this.TaxSubSections = response.Table;
          } else {
            this.TaxSubSections = [];
          }
          this.isDisabled = false;
        },
        complete: () => { },
        error: (error) => {
          this.isDisabled = false;
        },
      });
    } else {
      this.TaxSubSections = [];
    }
  }

  TaxSectionDetail_SelectLoad() {
    this.isDisabled = true;
    this.incometax.TaxSectionDetail_SelectLoad({ SelectType: 'S', ESS_TaxSectionDetailID: this.ID, ESS_TaxSectionMasterID: 0, FinancialYearFrom: '', FinancialYearTo: '' }).subscribe({
      next: (response) => {
        if (response.Table) {
          this.Detail.SelectType = 'update';
          this.Detail.ESS_TaxSubSectionFYMasterID = response.Table[0].ESS_TaxSubSectionFYMasterID;
          this.Detail.ESS_TaxSectionMasterID = response.Table[0].ESS_TaxSectionMasterId;
          this.Detail.SectionDescription = response.Table[0].SectionDescription;
          this.Detail.ESS_TaxSubSectionMasterID = response.Table[0].ESS_TaxSubSectionMasterId;
          this.Detail.SubSectionDescription = response.Table[0].SubSectionDescription;
          this.Detail.EarningDeduction = response.Table[0].EarningDeduction;
          this.Detail.IsOldRegimeApplicable = response.Table[0].IsOldRegimeApplicable;
          this.Detail.IsNewRegimeApplicable = response.Table[0].IsNewRegimeApplicable;
          this.Detail.IsOldMaxlimitapplicable = response.Table[0].IsOldMaxlimitapplicable;
          this.Detail.IsNewMaxlimitapplicable = response.Table[0].IsNewMaxlimitapplicable;
          this.Detail.OldRegimeMaxAmount = response.Table[0].OldRegimeMaxAmount;
          this.Detail.NewRegimeMaxAmount = response.Table[0].NewRegimeMaxAmount;
          try {
            this.Detail.ESS_TaxFinancialYearID = this.FinancialYears.filter(e => e.FinancialYearStart == response.Table[0].FinancialYearStart && e.FinancialYearEnd == response.Table[0].FinancialYearEnd)[0].ESS_TaxFinancialYearID;
          } catch {
            this.Detail.ESS_TaxFinancialYearID = null;
          }
          // this.Detail.YearStart = new Date(response.Table[0].FinancialYearStart).getFullYear();
          // this.Detail.YearEnd = new Date(response.Table[0].FinancialYearEnd).getFullYear();

          this.TaxSectionMasterSelectLoad();
          this.ESS_TaxSubSectionMasterSelect(false);
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }
  // TaxSectionDetail_SelectLoad() {
  //   this.isDisabled = true;
  //   this.incometax.TaxSectionDetail_SelectLoad({ SelectType: 'S', ESS_TaxSectionDetailID: this.Detail.ESS_TaxSectionDetailID, ESS_TaxSectionMasterID: 0, FinancialYearFrom: '', FinancialYearTo: '' }).subscribe({
  //     next: (response) => {
  //       if (response.Table || response.Table.length > 0) {
  //         this.Detail = response.Table[0];
  //         this.Detail.SelectType = 'update';
  //         this.Detail.Description = response.Table[0].SubSectionDescription;
  //         this.Detail.ESS_TaxSectionMasterID = response.Table[0].ESS_TaxSectionMasterId;

  //         if (response.Table[0].FinancialYearStart != null && response.Table[0].FinancialYearStart != '') {
  //           this.Detail.YearStart = new Date(response.Table[0].FinancialYearStart).getFullYear()
  //         }
  //         if (response.Table[0].FinancialYearEnd != null && response.Table[0].FinancialYearEnd != '') {
  //           this.Detail.YearEnd = new Date(response.Table[0].FinancialYearEnd).getFullYear()
  //         }
  //         this.TaxSectionMasterSelectLoad();
  //       }
  //       this.isDisabled = false;
  //     },
  //     complete: () => { },
  //     error: (error) => {
  //       this.isDisabled = false;
  //     },
  //   });
  // }

  async ESS_TaxSubSectionFYMaster_InsertUpdate() {
    if ((this.Detail.ESS_TaxSubSectionFYMasterID == 0 && this.common.PageRight.IsAdd) || (this.Detail.ESS_TaxSubSectionFYMasterID > 0 && this.common.PageRight.IsEdit)) {
      this.isDisabled = true;
      if (!this.Detail.IsOldRegimeApplicable) {
        this.Detail.IsOldMaxlimitapplicable = false;
        this.Detail.OldRegimeMaxAmount = null;
      }

      if (!this.Detail.IsOldMaxlimitapplicable) {
        this.Detail.OldRegimeMaxAmount = null;
      }

      if (!this.Detail.IsNewRegimeApplicable) {
        this.Detail.IsNewMaxlimitapplicable = false;
        this.Detail.NewRegimeMaxAmount = null;
      }

      if (!this.Detail.IsNewMaxlimitapplicable) {
        this.Detail.NewRegimeMaxAmount = null;
      }
      this.incometax.ESS_TaxSubSectionFYMaster_InsertUpdate(this.Detail).subscribe({
        next: async (response) => {
          if (response.Error_Code == '682' || response.Error_Code == '683') {
            const modalRef = this.modalService.open(AlertSuccessComponent, {
              size: 'md',
              backdrop: 'static',
              centered: true,
              windowClass: 'confirmation-modal'
            });
            modalRef.componentInstance.Message = response.Error_Message;
            modalRef.result.then((result: any) => {
              this.close(true);
            });
          } else {
            const modalRef = this.modalService.open(AlertWarningComponent, {
              size: 'md',
              backdrop: 'static',
              centered: true,
              windowClass: 'confirmation-modal'
            });
            modalRef.componentInstance.Message = response.Error_Message;
            modalRef.result.then((result: any) => { });
          }
          this.isDisabled = false;
        },
        complete: () => { },
        error: (error) => {
          this.isDisabled = false;
        },
      });
    } else {
      this.toast.show({ message: this.tooltip.Message.UnauthorizedMessage, type: toastTypeEnum.danger });
    }
  }

  // SetFinancialYearEnd() {
  //   this.TaxSections = [];
  //   this.Detail.ESS_TaxSubSectionFYMasterID = 0;
  //   if (this.Detail.YearStart != null && this.Detail.YearStart.toString().length == 4 && this.Detail.YearStart > 0) {
  //     this.Detail.YearEnd = parseInt(this.Detail.YearStart) + 1;
  //   } else {
  //     this.Detail.YearEnd = null
  //   }
  // }

  GetDesc(falg: string) {
    if (falg == 'Section') {
      if (this.Detail.ESS_TaxSectionMasterID != null && this.Detail.ESS_TaxSectionMasterID > 0) {
        this.Detail.SectionDescription = this.TaxSections.filter((e: any) => e.ESS_TaxSectionMasterID == this.Detail.ESS_TaxSectionMasterID)[0].Description;
      } else {
        this.Detail.SectionDescription = null;
      }
    } else if (falg == 'SubSection') {
      if (this.Detail.ESS_TaxSubSectionMasterID != null && this.Detail.ESS_TaxSubSectionMasterID > 0) {
        this.Detail.SubSectionDescription = this.TaxSubSections.filter((e: any) => e.ESS_TaxSubSectionMasterID == this.Detail.ESS_TaxSubSectionMasterID)[0].SubSectionDescription;
        this.Detail.EarningDeduction = this.TaxSubSections.filter((e: any) => e.ESS_TaxSubSectionMasterID == this.Detail.ESS_TaxSubSectionMasterID)[0].EarningDeduction;
      } else {
        this.Detail.SubSectionDescription = null;
        this.Detail.EarningDeduction = null;
      }
    }
  }

  ESS_TaxFinancialYearSelect() {
    this.isDisabled = true;
    this.incometax.ESS_TaxFinancialYearSelect({ SelectType: 'S', ESS_TaxFinancialYearID: null, FinancialYearFrom: null, FinancialYearTo: null }).subscribe({
      next: (response) => {
        if (response.Table) {
          this.FinancialYears = response.Table;
          this.FinancialYears.forEach(element => {
            element.FinancialYear = new Date(element.FinancialYearStart).getFullYear() + ' - ' + new Date(element.FinancialYearEnd).getFullYear();
          });
        } else {
          this.FinancialYears = [];
        }
        if (this.ID > 0) {
          this.TaxSectionDetail_SelectLoad();
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    })
  };

  close(flag = false) {
    this.activeModal.close(flag);
  }

  clear(type: number) {
    if (type == 1) {
      this.TaxSections = [];
      this.TaxSubSections = [];
      this.Detail.ESS_TaxSectionMasterID = null;
      this.Detail.ESS_TaxSubSectionMasterID = null;
      this.Detail.SectionDescription = null;
      this.Detail.SubSectionDescription = null;
    } else if (type == 2) {
      this.TaxSubSections = [];
      this.Detail.ESS_TaxSubSectionMasterID = null;
      this.Detail.SubSectionDescription = null;
    }
  }
}
